import React, { InputHTMLAttributes, useCallback } from 'react'
import { cep, telNumber } from '../masks'

import { Input } from './styles'

interface InputContentProps extends InputHTMLAttributes<HTMLInputElement> {
  id?: string
  padding?: string
  color?: string
  placeholderColor?: string
  mask?: string
}

export const InputContent = ({
  id,
  padding,
  color,
  placeholderColor,
  mask,
  ...props
}: InputContentProps) => {
  const handleKeyUp = useCallback(
    (event: React.FormEvent<HTMLInputElement>) => {
      switch (mask) {
        case 'telNumber':
          telNumber(event)
          break
        case 'cep':
          cep(event)
          break

        default:
          break
      }
    },
    [mask],
  )

  return (
    <Input
      id={id}
      color={color}
      placeholdercolor={placeholderColor}
      padding={padding}
      onKeyUp={handleKeyUp}
      // maxLength={mask === 'telNumber' ? 14 }
      {...props}
    />
  )
}
